import { render } from "./PenghargaanView.vue?vue&type=template&id=71aba00e"
import script from "./PenghargaanView.vue?vue&type=script&lang=js"
export * from "./PenghargaanView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__